/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-param-reassign, max-len */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsFillShareFill } from 'react-icons/bs';
import { Loader } from 'src/components';
import { JobDetailViewRendererProps } from '../../types';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
}

function Button({ className = '', children, ...props }: ButtonProps) {
  return (
    <button
      type="button"
      className={`border-0 border-none outline-none focus:outline-none ring-0 flex justify-center items-center ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

function Desktop(props: JobDetailViewRendererProps) {
  const {
    jobDetails,
    loading,
    onApplyJob,
    shareJob,
  } = props;

  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="fixed top-[50vh] left-[50vw]">
        <Loader />
      </div>
    );
  }
  return (
    <div className="bg-slate-50">
      <div className="relative min-h-screen">
        <div className="bg-[#00A6CF] md:h-[15rem]">
          <div className="mx-auto px-2 md:px-8 pt-8 pb-8 max-w-7xl">
            {/* <a href="/" className="z-50 flex justify-start w-[10rem] md:w-[6rem] h-[30px] md:h-[20px]">
              <img src={jobDetails?.clientLogo ? jobDetails?.clientLogo : '/avatars/white.png'} width="100" height="30" className="object-contain" alt="company logo" />
            </a> */}
            <div className="flex justify-start pt-16 font-bold text-base text-white">{jobDetails?.jobTitle}</div>

            <div className="flex md:flex-row flex-col md:justify-between md:items-end gap-y-5 pt-8">
              <div className="flex flex-col justify-start text-lg text-white">
                <div className="">{jobDetails?.location.join(', ').toUpperCase()}</div>
                <div className="text-left">{jobDetails?.createdDate}</div>
              </div>

              <div className="text-lg text-white">
                JOB ID:
                {' '}
                <span className="font-bold">
                  {jobDetails?.jobId}
                </span>
              </div>

              <div className="text-lg text-white">
                JOB TYPE:
                {' '}
                <span className="font-bold">
                  {jobDetails?.jobType}
                  {jobDetails?.jobDuration ? ` (${jobDetails?.jobDuration})` : ''}
                </span>
              </div>

              <div className="flex space-x-2">
                <Button
                  className="bg-white rounded-full w-8 h-8 p-0"
                  onClick={async () => {
                    await shareJob();
                  }}
                >
                  <BsFillShareFill color="#00A6CF" className="p-0" />
                </Button>
                <Button
                  className="bg-white rounded-full w-16 h-8"
                  onClick={() => navigate(`/${jobDetails?.organizationId}/careers`)}
                >
                  Back
                </Button>
                <Button
                  className="bg-white rounded-full w-28 h-8"
                  onClick={onApplyJob}
                >
                  Apply Now
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="relative md:top-[15rem] bottom-0 md:absolute bg-white w-full mx-auto px-2 md:px-8 pt-8 pb-12 max-w-7xl overflow-auto">
            <div className="font-bold text-lg text-left">What we are looking for</div>

            <div className="flex flex-col justify-start pt-3 text-left" dangerouslySetInnerHTML={{ __html: jobDetails?.jobDescription as string }} />

            <div className="flex justify-center space-x-2 pt-5">
              <Button
                className="bg-[#00A6CF] rounded-full w-8 h-8"
                onClick={() => shareJob()}
              >
                <BsFillShareFill className="mx-auto" color="#fff" />
              </Button>
              <Button
                className="bg-[#00A6CF] rounded-full w-28 h-8 text-white"
                onClick={() => onApplyJob()}
              >
                Apply Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Desktop;
